module.exports = __webpack_public_path__ + "img/item-title.ad1aaeff.png";